export default "<div class=\"container\">\n    <h1>Order cancelled</h1>\n    <p>Redirecting to menu, do not close this tab...</p>\n</div>"